(function () {
  'use strict';
  var cfg = window.DV_PACK;
  var root = document.getElementById('dv-pack-builder');
  if (!cfg || !root || !cfg.variants || !cfg.variants.length) return;
  root.classList.add('dvpb');

  function norm(s) { return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); }

  var HEX = {};
  [['Arena', '#C7B299'], ['Blanco Lino', '#EBE4D5'], ['Verde Oliva', '#44452E'],
   ['Azul Bahía', '#8FA3BC'], ['Negro Carbón', '#262626'], ['Mocca', '#5C4138']]
    .forEach(function (p) { HEX[norm(p[0])] = p[1]; });
  function hexDe(color) { return HEX[norm(color)] || '#CCC'; }

  function perUnit(n) { return n >= 4 ? 67990 : n === 3 ? 73330 : n === 2 ? 79995 : 99990; }
  function fmt(n) { return '$' + n.toLocaleString('es-CO'); }

  var colores = [], tallas = [];
  cfg.variants.forEach(function (v) {
    if (colores.indexOf(v.color) === -1) colores.push(v.color);
    if (tallas.indexOf(v.talla) === -1) tallas.push(v.talla);
  });

  var sel = { color: null, talla: null };
  var slots = [];

  root.innerHTML =
    '<h2 class="dvpb__title">Arma tu pack</h2>' +
    '<p class="dvpb__tabla">1 · $99.990 &nbsp;—&nbsp; 2 · $159.990 ($79.995 c/u) &nbsp;—&nbsp; 3 · $219.990 ($73.330 c/u) &nbsp;—&nbsp; 4 o más · $67.990 c/u</p>' +
    '<p class="dvpb__label">Color<span class="dvpb__sel" data-dvpb="color-nombre"></span></p>' +
    '<div class="dvpb__swatches" data-dvpb="colores" role="group" aria-label="Color"></div>' +
    '<p class="dvpb__label">Talla</p>' +
    '<div class="dvpb__sizes" data-dvpb="tallas" role="group" aria-label="Talla"></div>' +
    '<button type="button" class="dvpb__add" data-dvpb="agregar">Agregar al pack</button>' +
    '<div class="dvpb__chips" data-dvpb="chips"></div>' +
    '<p class="dvpb__resumen" data-dvpb="resumen" role="status"></p>' +
    '<button type="button" class="dvpb__pagar" data-dvpb="pagar">Ir a pagar ahora</button>' +
    '<button type="button" class="dvpb__cart" data-dvpb="carrito">Pagar al recibir</button>';

  var el = function (k) { return root.querySelector('[data-dvpb="' + k + '"]'); };
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      ocupado = false;
      el('pagar').textContent = 'Ir a pagar ahora';
      el('carrito').textContent = 'Pagar al recibir';
      el('pagar').removeAttribute('aria-busy');
      el('carrito').removeAttribute('aria-busy');
      paint();
    }
  });

  colores.forEach(function (c) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dvpb__sw';
    b.style.background = hexDe(c);
    b.setAttribute('aria-label', c);
    b.setAttribute('aria-pressed', 'false');
    b.addEventListener('click', function () { pick('color', c); });
    el('colores').appendChild(b);
  });

  tallas.forEach(function (t) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dvpb__sz';
    b.textContent = t;
    b.setAttribute('aria-pressed', 'false');
    b.addEventListener('click', function () { pick('talla', t); });
    el('tallas').appendChild(b);
  });
  marcarAgotados();

  function pick(kind, value) {
    sel[kind] = value;
    var group = kind === 'color' ? el('colores') : el('tallas');
    Array.prototype.forEach.call(group.children, function (b) {
      var name = kind === 'color' ? b.getAttribute('aria-label') : b.textContent;
      b.setAttribute('aria-pressed', name === value ? 'true' : 'false');
    });
    if (kind === 'color') {
      el('color-nombre').textContent = ' · ' + value;
      // El picker nativo (oculto) es la fuente de verdad de la galería agrupada:
      // clicarlo dispara la cascada del theme (grupo + foto de estudio + slider).
      if (!syncPickerNativo(value)) syncGaleria(value);
    } else {
      syncPickerNativo(value);
    }
    marcarAgotados();
    paint();
  }

  function syncPickerNativo(valor) {
    try {
      var vp = document.querySelector('variant-picker');
      if (!vp) return false;
      var radios = vp.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === valor) {
          if (!radios[i].checked) radios[i].click();
          return true;
        }
      }
    } catch (e) { }
    return false;
  }

  function syncGaleria(color) {
    try {
      var gal = document.querySelector('media-gallery');
      if (!gal) return;
      // Vía nativa: agrupación de media por variante (Symmetry). El grupo se llama como el
      // valor de la opción Color; su primera media (position 'start') es la foto de estudio.
      var datosEl = gal.querySelector('.js-data-variant-media');
      if (datosEl && typeof gal.setActiveMediaGroup === 'function' && typeof gal.setActiveMedia === 'function') {
        var datos = JSON.parse(datosEl.textContent);
        if (datos && datos.media) {
          gal.setActiveMediaGroup(color);
          var ids = Object.keys(datos.media);
          for (var i = 0; i < ids.length; i++) {
            if (datos.media[ids[i]].group === color && datos.media[ids[i]].position === 'start') {
              gal.setActiveMedia(ids[i], true);
              return;
            }
          }
          return;
        }
      }
      // Respaldo (esquema anterior): casar la foto de la variante por nombre de archivo.
      var v = cfg.variants.filter(function (x) { return x.color === color && x.img; })[0];
      if (!v || typeof gal.setActiveMedia !== 'function') return;
      var file = v.img.split('/').pop().split('?')[0];
      var items = gal.querySelectorAll('.thumbnails .slider__item');
      if (!items.length) items = gal.querySelectorAll('.main-image .slider__item');
      for (var j = 0; j < items.length; j++) {
        var img = items[j].querySelector('img');
        var src = img ? (img.currentSrc || img.src || '') : '';
        if (src.split('/').pop().split('?')[0] === file && items[j].dataset.mediaId) {
          gal.setActiveMedia(items[j].dataset.mediaId, true);
          return;
        }
      }
    } catch (e) { }
  }

  function variantFor(color, talla) {
    return cfg.variants.filter(function (v) { return v.color === color && v.talla === talla; })[0];
  }

  // ── Combinaciones agotadas (2026-09-19) ────────────────────────────────────
  // Con una talla elegida se marcan los colores sin stock en esa talla; con un
  // color elegido, las tallas sin stock en ese color; sin nada elegido, solo lo
  // agotado en todas sus combinaciones. El botón marcado SIGUE siendo clicable
  // (patrón Shopify): el usuario puede cambiar de opción sin quedar atrapado, y
  // "Agregar" ya explica por qué no. Ni aria-label ni textContent se tocan:
  // pick() los usa para casar el botón con su valor.
  function disponible(color, talla) {
    var v = variantFor(color, talla);
    return !!(v && v.ok !== false);
  }
  function marcar(b, agotado, titulo) {
    if (agotado) { b.setAttribute('data-agotado', '1'); b.setAttribute('title', titulo); }
    else { b.removeAttribute('data-agotado'); b.removeAttribute('title'); }
  }
  function marcarAgotados() {
    Array.prototype.forEach.call(el('colores').children, function (b) {
      var c = b.getAttribute('aria-label');
      var hay = sel.talla ? disponible(c, sel.talla)
                          : tallas.some(function (t) { return disponible(c, t); });
      marcar(b, !hay, sel.talla ? 'No disponible en talla ' + sel.talla : 'No disponible por ahora');
    });
    Array.prototype.forEach.call(el('tallas').children, function (b) {
      var t = b.textContent;
      var hay = sel.color ? disponible(sel.color, t)
                          : colores.some(function (c) { return disponible(c, t); });
      marcar(b, !hay, sel.color ? 'No disponible en ' + sel.color : 'No disponible por ahora');
    });
  }
  // Cuántas veces la gente toca una combinación agotada (Clarity).
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.dvpb__sw[data-agotado], .dvpb__sz[data-agotado]');
    if (b && window.clarity) { try { window.clarity('event', 'dv_pdp_toca_agotado'); } catch (err) {} }
  }, true);

  el('agregar').addEventListener('click', function () {
    if (!sel.color && !sel.talla) { aviso('Elige el color y la talla de tu primera camiseta.'); return; }
    if (!sel.color) { aviso('Te falta elegir el color.'); return; }
    if (!sel.talla) { aviso('Te falta elegir la talla.'); return; }
    var v = variantFor(sel.color, sel.talla);
    if (!v || v.ok === false) { aviso('Esa combinación no está disponible por ahora.'); return; }
    slots.push({ id: v.id, color: sel.color, talla: sel.talla });
    paint();
  });

  function aviso(msg) { el('resumen').textContent = msg; }

  function quitar(i) {
    slots.splice(i, 1);
    paint();
    var qs = el('chips').querySelectorAll('.dvpb__quitar');
    if (qs.length) { qs[Math.max(0, i - 1)].focus(); } else { el('agregar').focus(); }
  }

  function paint() {
    var chips = el('chips');
    chips.innerHTML = '';
    slots.forEach(function (s, i) {
      var chip = document.createElement('div');
      chip.className = 'dvpb__chip';
      var dot = document.createElement('span');
      dot.className = 'dvpb__dot';
      dot.style.background = hexDe(s.color);
      var txt = document.createElement('span');
      txt.textContent = s.color + ' · ' + s.talla;
      chip.appendChild(dot);
      chip.appendChild(txt);
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'dvpb__quitar';
      x.setAttribute('aria-label', 'Quitar ' + s.color + ' talla ' + s.talla);
      x.textContent = '×';
      x.addEventListener('click', function () { quitar(i); });
      chip.appendChild(x);
      chips.appendChild(chip);
    });

    var n = slots.length;
    var r = el('resumen');
    if (n === 0) {
      r.classList.add('dvpb__resumen--guia');
      r.innerHTML = '<strong>El pack se arma camiseta por camiseta.</strong> Elige color y talla, y agrégala al pack. Al final, ve a pagar.';
    } else {
      r.classList.remove('dvpb__resumen--guia');
      var total = n * perUnit(n);
      r.innerHTML = n + (n === 1 ? ' camiseta — ' : ' camisetas — ') + '<strong>' + fmt(total) + '</strong>' +
        (n >= 2 ? ' <span class="dvpb__cu">· ' + fmt(perUnit(n)) + ' por camiseta</span>' : '');
    }
    el('pagar').disabled = n === 0;
    el('carrito').disabled = n === 0;
  }

  function sincronizarCarrito() {
    var updates = {};
    cfg.variants.forEach(function (v) { updates[v.id] = 0; });
    slots.forEach(function (s) { updates[s.id] = (updates[s.id] || 0) + 1; });
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (j) { throw new Error(j && j.description ? j.description : 'cart'); });
      }
      return res;
    });
  }

  var ocupado = false;

  // Releasit (form v2 embebido) deja su dialog popup con display:none al no existir su app
  // block en el template; el dialog abre con showModal (congela la página) pero jamás se pinta.
  // Con [open] lo mostramos nosotros, sin sus animaciones para no depender de esa coreografía.
  if (!document.getElementById('dv-cod-fix')) {
    var codCss = document.createElement('style');
    codCss.id = 'dv-cod-fix';
    codCss.textContent =
      'dialog#rsi_form_wrapper[open]{display:flex !important;opacity:1 !important;animation:none !important}' +
      'dialog#rsi_form_wrapper[open] ._rsi_main_form_element{display:block !important;opacity:1 !important;animation:none !important}' +
      'dialog#rsi_form_wrapper[open] .rsi-form-content-wrapper{opacity:1 !important}' +
      // La clase rsi_animation_none de Releasit computa display:none (bug de su build) y
      // esconde los botones de acción del form (Paga al recibir / Pagar en línea).
      'dialog#rsi_form_wrapper[open] button.rsi_animation_none{display:flex !important}' +
      // El variant-picker nativo existe solo como motor de la agrupación de la galería
      // (el theme lo exige en el DOM); el builder es la única UI de selección.
      '.template-suffix-oficial variant-picker{display:none !important}';
    document.head.appendChild(codCss);
  }

  function codEstadoAbierto() {
    try { return !!(window._rsiV2 && window._rsiV2.getState().isOpen); } catch (e) { return false; }
  }

  // Lo que el cliente ya llenó en el form COD (todo o parcial) viaja al checkout como
  // parámetros de pre-llenado de Shopify; los consume la redirección y la URL final queda
  // limpia. Solo se pasan campos con valor.
  function codDatosPrefill() {
    var params = [];
    try {
      var dlg = document.querySelector('#rsi_form_wrapper');
      if (!dlg) return '';
      var mapa = [
        [/correo|email/i, 'checkout[email]', null],
        [/apellido|last/i, 'checkout[shipping_address][last_name]', null],
        [/nombre|first/i, 'checkout[shipping_address][first_name]', null],
        [/whatsapp|phone|tel[eé]fono/i, 'checkout[shipping_address][phone]', function (v) {
          var d = v.replace(/\D/g, '');
          return d.length === 10 ? '+57' + d : v;
        }],
        [/barrio|detalle|civic|address2/i, 'checkout[shipping_address][address2]', null],
        [/direcci|calle|address/i, 'checkout[shipping_address][address1]', null],
        [/departamento|province/i, 'checkout[shipping_address][province]', null],
        [/ciudad|city/i, 'checkout[shipping_address][city]', null]
      ];
      var usados = {};
      Array.prototype.forEach.call(dlg.querySelectorAll('input, select'), function (el) {
        if (el.type === 'checkbox' || el.type === 'hidden') return;
        var clave = (el.name || '') + ' ' + (el.placeholder || '') + ' ' + (el.getAttribute('aria-label') || '');
        var valor = String(el.value || '').trim();
        if (!valor) return;
        for (var i = 0; i < mapa.length; i++) {
          if (usados[mapa[i][1]]) continue;
          if (mapa[i][0].test(clave)) {
            usados[mapa[i][1]] = true;
            var v = mapa[i][2] ? mapa[i][2](valor) : valor;
            params.push(encodeURIComponent(mapa[i][1]) + '=' + encodeURIComponent(v));
            break;
          }
        }
      });
      if (params.length) {
        params.push(encodeURIComponent('checkout[shipping_address][country]') + '=' + encodeURIComponent('Colombia'));
      }
    } catch (e) { }
    return params.length ? '?' + params.join('&') : '';
  }

  // "Pagar en línea" DENTRO del form COD va al checkout estándar. El flujo nativo de
  // Releasit crea un draft order que arrastra el envío contraentrega de $15.000 (su
  // descuento compensatorio fue borrado de la tienda) y llega con la dirección a medias;
  // el checkout estándar cobra bien: pack con descuento automático + envío gratis +
  // dirección validada, pre-llenada con lo que el cliente ya escribió en el form.
  // Captura en document para ganarle al handler de React de la app.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#rsi_form_wrapper .rsi-additionals_checkout_button');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = ROOT + 'checkout' + codDatosPrefill();
  }, true);

  function ocupar(boton, textoEspera) {
    ocupado = true;
    var original = boton.textContent;
    boton.textContent = textoEspera;
    boton.setAttribute('aria-busy', 'true');
    el('pagar').disabled = true;
    el('carrito').disabled = true;
    return original;
  }

  function restaurar(boton, original) {
    ocupado = false;
    boton.textContent = original;
    boton.removeAttribute('aria-busy');
    paint();
  }

  function fallo(boton, original, err) {
    restaurar(boton, original);
    aviso(err && err.message && err.message !== 'cart' ? err.message : 'No se pudo procesar. Revisa tu conexión e intenta de nuevo.');
  }

  el('pagar').addEventListener('click', function () {
    if (!slots.length || ocupado) return;
    var boton = el('pagar');
    var original = ocupar(boton, 'Un momento…');
    sincronizarCarrito().then(function () {
      window.location.href = ROOT + 'checkout';
    }).catch(function (err) { fallo(boton, original, err); });
  });

  el('carrito').addEventListener('click', function () {
    if (!slots.length || ocupado) return;
    var boton = el('carrito');
    var original = ocupar(boton, 'Un momento…');
    sincronizarCarrito().then(function () {
      // Releasit carga su formulario en diferido: se espera con paciencia. El re-click
      // solo ocurre si la app dice que el form NO está abierto (evita alternar abrir/cerrar),
      // y el refresh del drawer va después, para no borrar el botón justo antes de clicarlo.
      var t0 = Date.now();
      var ultimoClick = 0;
      var timer = setInterval(function () {
        if (document.querySelector('#rsi_form_wrapper[open]')) {
          clearInterval(timer);
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          restaurar(boton, original);
          return;
        }
        var ahora = Date.now();
        if (!codEstadoAbierto() && ahora - ultimoClick > 1200) {
          var rsi = document.querySelector('#cart-wrapper #rsi_buy_now_button');
          if (rsi) { ultimoClick = ahora; rsi.click(); }
        }
        if (ahora - t0 > 9000) {
          clearInterval(timer);
          // Si la app cree tener el form abierto pero jamás lo pintó, se cierra para
          // no dejar la página congelada bajo un modal invisible.
          try { var d = document.querySelector('#rsi_form_wrapper'); if (d && d.open && typeof d.close === 'function') d.close(); } catch (e) { }
          try { if (codEstadoAbierto()) window._rsiV2.setState({ isOpen: false }); } catch (e) { }
          if (document.querySelector('cart-drawer')) {
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
            }, 900);
            restaurar(boton, original);
          } else {
            window.location.href = ROOT + 'cart';
          }
        }
      }, 250);
    }).catch(function (err) { fallo(boton, original, err); });
  });

  paint();

  // Empujón inicial de la galería agrupada: si el init del theme aún no filtró
  // (whenComponentLoaded tarda en algunos entornos), se aplica el grupo del color
  // seleccionado en el picker. Idempotente: si el theme ya lo hizo, no cambia nada.
  setTimeout(function () {
    try {
      var gal = document.querySelector('media-gallery');
      var vp = document.querySelector('variant-picker');
      if (!gal || !vp || gal.currentMediaGroup !== undefined || typeof gal.setActiveMediaGroup !== 'function') return;
      var rs = vp.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < rs.length; i++) {
        if (colores.indexOf(rs[i].value) !== -1) { gal.setActiveMediaGroup(rs[i].value); return; }
      }
    } catch (e) { }
  }, 1500);
})();
